module.exports = __webpack_public_path__ + "static/img/huawei-logo.50ede23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huawei-logo.png
// module id = 0Gvu
// module chunks = 1